import script from "./homeIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./homeIndex.vue?vue&type=script&setup=true&lang=js"

import "./homeIndex.vue?vue&type=style&index=0&id=f23ecda2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f23ecda2"]])

export default __exports__